import React from 'react';
import { Button, Space } from 'antd';
import { RocketOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const GuestBottomBar = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: 'linear-gradient(135deg, #0072ff 0%, #00d4ff 100%)',
        padding: '12px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
        boxShadow: '0 -2px 12px rgba(0,0,0,0.15)',
      }}
    >
      <Space size={16} align="center">
        <span style={{ color: '#fff', fontSize: 14, fontWeight: 500 }}>
          無料登録でリサーチ＆記事生成を体験できます
        </span>
        <Button
          size="middle"
          icon={<RocketOutlined />}
          onClick={() => navigate('/register')}
          style={{
            background: '#fff',
            color: '#0072ff',
            border: 'none',
            fontWeight: 700,
            boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
          }}
        >
          登録して試してみる
        </Button>
      </Space>
    </div>
  );
};

export default GuestBottomBar;
